import { ACTION_USER_PERMISSIONS, ACTION_USER_PROFILE } from '../actions/actionTypes'

const initialState = {
  profile: {},
  permissions: [],
}

function toPermissionId(permission) {
  if (permission == null) return null
  if (typeof permission === 'number' && Number.isFinite(permission)) return permission
  if (typeof permission === 'string' && permission.trim() !== '') {
    const n = Number(permission)
    return Number.isFinite(n) ? n : null
  }
  if (typeof permission === 'object' && permission.id != null) {
    const n = Number(permission.id)
    return Number.isFinite(n) ? n : null
  }
  return null
}

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_USER_PERMISSIONS:
      return {
        ...state,
        permissions: Array.isArray(action.permissions)
          ? action.permissions.map(toPermissionId).filter((id) => id != null)
          : []
      }
    case ACTION_USER_PROFILE:
        return {
          ...state,
          profile: action.profile
        }
    default:
      return state
  }
}
